/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  LibLiquidityProviderRichErrors1,
  LibLiquidityProviderRichErrors1Interface,
} from "../LibLiquidityProviderRichErrors1";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "providerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "makerToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "takerToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "sellAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "boughtAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minBuyAmount",
        type: "uint256",
      },
    ],
    name: "LiquidityProviderIncompleteSellError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

export class LibLiquidityProviderRichErrors1__factory {
  static readonly abi = _abi;
  static createInterface(): LibLiquidityProviderRichErrors1Interface {
    return new utils.Interface(
      _abi
    ) as LibLiquidityProviderRichErrors1Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LibLiquidityProviderRichErrors1 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LibLiquidityProviderRichErrors1;
  }
}
